import React, {
  useState
}                          from 'react';
import PropTypes           from 'prop-types';
import clsx                from 'clsx';
import { useTranslation }  from 'react-i18next';
import { withRouter }      from 'react-router-dom';
import Input               from '@material-ui/core/Input';
import card_membership     from '@material-ui/icons/CardMembership';
import Paper               from '~/components/Paper';
import InputControl        from '~/components/Input/InputControl';
import InputDropzone       from '~/components/Input/InputDropzone';
import GridContainer       from '~/components/GridContainer';
import GridItem            from '~/components/GridItem';
import useStyles           from './styles';
import Form                from '~/containers/Form';
import CardPreview         from '~/components/Card/CardPreview';
import InputSelect         from '~/components/Input/InputSelect';
import InputColorPicker    from '~/components/Input/InputColorPicker/InputColorPicker';
import InputCheckBox       from '~/components/Input/InputCheckBox';
import CardRecord          from '~/records/CardRecord';
import cardTypeEnum        from '~/enums/cardTypeEnum';

const attrName = (attr) => CardRecord.hummanAttributeName(attr);

function CardsItem({record, handleChange, loading, onSubmit, setRecord}) {
  const classesRoot = useStyles();
  const [ showPicker, setShowPicker ] = useState( { title: false, text: false, background: false} );
  const [hasImage, setHasImage] = useState(false);
  const { t } = useTranslation();
  const isPersisted = record.isPersisted();
  const typeFromApi = record.get('type');
  const imageUpload = record.get('type') === 'img_bg';

  return (
    <Form
      onSubmit={() => onSubmit(hasImage)}
      isPersisted={isPersisted}
    >
      <Paper
        Icon={ card_membership }
        iconColor={isPersisted ? 'purple' : 'green'}
        title={t('cards.defSingular')}
        loading={ loading }
      >
        <div className={ clsx(classesRoot.root) }>
          <GridContainer>
            <GridItem xs={8} md={6}>
              <GridContainer>
                <GridItem xs={12} md={8} lg={11}>
                  <InputControl
                    name='name'
                    value={record.get('name')}
                    disabled={loading}
                    label={attrName('name')}
                    inputComponent={Input}
                    onChange={handleChange}
                  />
                </GridItem>
                <GridItem xs={12} md={4} lg={1}>
                  <InputControl
                    name='is_active'
                    value={record.get('is_active')}
                    disabled={loading}
                    label={attrName('is_active')}
                    inputComponent={InputCheckBox}
                    onChange={handleChange}
                  />
                </GridItem>
              </GridContainer>
              <GridContainer>
                <GridItem xs={12}>
                  <InputControl
                    name='description'
                    value={record.get('description')}
                    disabled={loading}
                    label={attrName('description')}
                    inputComponent={Input}
                    InputProps={{
                      multiline:true,
                      rows:'3',
                    }}
                    onChange={handleChange}
                  />
                </GridItem>

              </GridContainer>
              <GridContainer>
                <GridItem md={4}>
                  <InputControl
                    value={record.get('bg_color')}
                    name="bg_color"
                    disabled={loading}
                    label={attrName('bg_color')}
                    inputComponent={InputColorPicker }
                    InputProps={{
                      color: record.get('bg_color'),
                      showPicker: showPicker.background,
                      switchPicker: () => setShowPicker({...showPicker, background: !showPicker.background}),
                    }}
                    onChange={(bgColor) => {
                      setRecord(record.updateAttributes({bg_color: bgColor.hex}));
                    }}
                    />
                </GridItem>
                <GridItem md={4}>
                  <InputControl
                    value={record.get('title_color')}
                    name="title_color"
                    disabled={loading }
                    label={attrName('title_color')}
                    inputComponent={ InputColorPicker }
                    InputProps={{
                      color: record.get('title_color'),
                      showPicker: showPicker.title,
                      switchPicker: () => setShowPicker({...showPicker, title: !showPicker.title}),
                    }}
                    onChange={ ( titleColor ) => {
                      setRecord(record.updateAttributes({title_color: titleColor.hex}));
                    }}
                    />
                </GridItem>
                <GridItem md={4}>
                  <InputControl
                    value={record.get('text_color')}
                    name="text_color"
                    disabled={loading }
                    label={attrName('text_color')}
                    inputComponent={ InputColorPicker }
                    InputProps={{
                      color: record.get('text_color'),
                      showPicker: showPicker.text,
                      switchPicker: () => setShowPicker({...showPicker, text: !showPicker.text}),
                    }}
                    onChange={(textColor) => {
                      setRecord(record.updateAttributes({text_color: textColor.hex}));
                    }}
                    />
                </GridItem>
              </GridContainer>
              <GridContainer>
                <GridItem md={6}>
                  <InputControl
                    value={record.get('type')}
                    name="type"
                    disabled={loading}
                    label={attrName('type')}
                    inputComponent={InputSelect}
                    InputProps={{
                      options: cardTypeEnum().array,
                      placeholder: t('cards-type-placeholder'),
                      outValueType: 'string'
                    }}
                    onChange={handleChange}
                    />
                </GridItem>
                <GridItem md={6}>
                  <InputControl
                    value={record.get('image_base64')}
                    name="image_base64"
                    disabled={loading || imageUpload }
                    label={attrName('image_base64')}
                    inputComponent={ InputDropzone }
                    InputProps={{
                      image: record.get('image_base64'),
                      sendAlready: imageUpload
                    }}
                    onChange={(image_base64) => {
                      setRecord(record.updateAttributes(image_base64));
                      setHasImage(true);
                    }}
                  />
                </GridItem>
              </GridContainer>
              <GridContainer>
                <GridItem xs={12}>
                  <InputControl
                    name='url'
                    value={record.get('url')}
                    disabled={loading}
                    label={attrName('url')}
                    inputComponent={Input}
                    onChange={handleChange}
                  />
                </GridItem>
              </GridContainer>
            </GridItem>
            <GridItem xs={8} md={6}>
              <InputControl
                value={record.get('image_id')}
                name="image_id"
                disabled={loading}
                label={t('Card')}
                inputComponent={CardPreview}
                InputProps={{
                  loading: loading,
                  cardType: typeFromApi,
                  background: record.get('bg_color'),
                  text_color: record.get('text_color'),
                  title_color: record.get('title_color'),
                  title: record.get('name'),
                  image: record.get('image_base64') ? `data:image/png;base64,${record.get('image_base64')}`: record.get('image') ? record.getImageUrl(): null,
                  description: record.get('description'),
                  url: record.get('url'),
                }}
                onChange={handleChange}
              />
            </GridItem>
          </GridContainer>
        </div>
      </Paper>
    </Form>
  );
}

CardsItem.propTypes={
  record: PropTypes.instanceOf(CardRecord).isRequired,
  handleChange: PropTypes.func.isRequired,
  loading: PropTypes.bool,
  onSubmit: PropTypes.func.isRequired,
  setRecord: PropTypes.func.isRequired,
};

CardsItem.defaultProps={
  loading: false,
};

export default React.memo(withRouter(CardsItem));
